import { getDatabase, onValue, ref } from 'firebase/database';
import { getPriorityInfo, PriorityInfo } from '../services/buildfire/rdb/cases';
import { FirebaseApp } from 'firebase/app';
import React from 'react';
import { LOADING_STATE } from '../util/loading';

function usePriorityCaseSettings(
  app?: FirebaseApp
): { loadingState: LOADING_STATE } & Partial<PriorityInfo> {
  const [loadingState, setLoadingState] = React.useState(LOADING_STATE.LOADING);
  const [priorityCaseSettings, setSettings] = React.useState<PriorityInfo>();

  React.useEffect(() => {
    if (!app) {
      return;
    }

    const db = getDatabase(app);
    const priorityRef = ref(db, 'priority');
    onValue(
      priorityRef,
      async (snapshot) => {
        setLoadingState(LOADING_STATE.LOADED);
        if (!snapshot.exists()) {
          setSettings({
            enabled: false,
            businessStart: '08:00',
            businessEnd: '16:00',
            price: 2800,
          });
          return;
        }

        const priorityData = snapshot.val();
        if (priorityData) {
          const settings = await getPriorityInfo(db);
          setSettings(settings);
        }
      },
      (e) => {
        console.error('Error fetching priority case settings:', e);
        setLoadingState(LOADING_STATE.ERROR);
      }
    );
  }, [app]);

  return {
    ...priorityCaseSettings,
    loadingState,
  };
}

export default usePriorityCaseSettings;
